export default __webpack_public_path__ + "static/media/star.22e62068.svg";